/**
 * The browser's best knowledge of the account it acts for — the SAME derivation the
 * OpenRouter / Perplexity / translator clients have each carried privately since the
 * log-attribution work (localStorage `user_accounts`, then the URL's first path segment).
 * Exported once so the decision client can stamp it on `X-Account-Id`: anthropicProxy
 * reads that header, passes the account into `callDecision`, and the fleet proxy bills
 * the decision without a session lookup (2026-09-06 — the `thread-label` decision was
 * the last browser call still recording UNRESOLVED ACCOUNT on every turn). The three
 * private copies are candidates to fold onto this one.
 */
export function getAccountHint(): string {
  try {
    const raw = localStorage.getItem('user_accounts');
    if (raw) {
      const accounts = JSON.parse(raw);
      if (Array.isArray(accounts) && accounts.length > 0 && accounts[0].accountId) {
        return String(accounts[0].accountId);
      }
    }
    const pathPart = window.location.pathname.split('/')[1];
    return pathPart || 'unknown';
  } catch {
    return 'unknown';
  }
}

/** The hint when it names an account, '' when the browser does not know one yet. */
export function knownAccountHint(): string {
  const hint = getAccountHint();
  return hint && hint !== 'unknown' ? hint : '';
}
